import { render, staticRenderFns } from "./paymentDetails.vue?vue&type=template&id=b6d8ae76&scoped=true"
import script from "./paymentDetails.vue?vue&type=script&lang=js"
export * from "./paymentDetails.vue?vue&type=script&lang=js"
import style0 from "./paymentDetails.vue?vue&type=style&index=0&id=b6d8ae76&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6d8ae76",
  null
  
)

export default component.exports